import { useUserData } from '../../../../../hooks'
import { useApplicantMoveToScreening } from '../../RentalPortalApplicantProfileHeaderStageSelect'
import {
  APPLICANT_CREDIT_CHECK_ACTION,
  APPLICANT_DECISION_ACTION,
  useApplicantCreditCheckVerdict,
} from '../../RentalPortalApplicantProfileTabOverview'
import { useApplicantProfileContext } from '../useApplicantProfileContext'

import { APPLICANT_ATTENTION_DESTINATION } from './useApplicantAttentionAction.constants'
import {
  getApplicantAttentionActionState,
  getApplicantAttentionPrimaryAction,
} from './useApplicantAttentionAction.utils'

export function useApplicantAttentionAction() {
  const currentUser = useUserData()

  const { applicantData, decisionActions } = useApplicantProfileContext()

  const { handleClickMoveToScreening } = useApplicantMoveToScreening()

  const { handleOpenVerdictForm } = useApplicantCreditCheckVerdict()

  const primaryAction = getApplicantAttentionPrimaryAction({
    applicantData,
    currentUserId: currentUser?.id,
  })

  const { destination, isDisabled, isFullPageOnly } =
    getApplicantAttentionActionState(primaryAction)

  function handleOpenVerdictFormAction() {
    handleOpenVerdictForm(APPLICANT_CREDIT_CHECK_ACTION.recordVerdict)
  }

  function handleClickApprove() {
    decisionActions.handleClickAction(APPLICANT_DECISION_ACTION.approve)
  }

  const destinationHandlers = {
    [APPLICANT_ATTENTION_DESTINATION.approve]: handleClickApprove,
    [APPLICANT_ATTENTION_DESTINATION.moveToScreening]:
      handleClickMoveToScreening,
    [APPLICANT_ATTENTION_DESTINATION.recordVerdict]:
      handleOpenVerdictFormAction,
  }

  return {
    handleClickAction: destinationHandlers[destination],
    isActionDisabled: isDisabled,
    isActionFullPageOnly: isFullPageOnly,
    primaryAction,
  }
}
